export const openBase64Image = (base64String) => {
    const newWindow = window.open();
    newWindow.document.write(`
      <html>
      <head>
      <title>Base64 Image</title>
      </head>
      <body>
      <img src="${base64String}" />
      </body>
      </html>
      `);
}